/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ColorFillIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Color Fill',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10.91113,9.42188c-.19238,0-.38379-.07324-.53027-.21973L3.67871,2.50098c-.29297-.29297-.29297-.76758,0-1.06055s.76758-.29297,1.06055,0l6.70215,6.70117c.29297.29297.29297.76758,0,1.06055-.14648.14648-.33789.21973-.53027.21973Z"
      fill="currentColor"
    />
    <path
      d="M17.58325,9.16895c-.32153-.39404-.71692-.7644-1.08691-1.05859-.00122-.00122-.00195-.00269-.00317-.00391l-4.64941-4.64746c-.5293-.5293-1.28711-.75879-2.02051-.61816-.40723.0791-.67285.47266-.59375.87891.07812.40625.47852.6709.87891.59375.24219-.0498.49707.02832.6748.20605l4.64941,4.64844c.14258.1416.2207.3291.2207.5293s-.07812.38867-.21973.53027l-6.00293,6.00293c-.29297.29297-.76758.29297-1.06055,0l-4.64941-4.64844c-.29297-.29297-.29297-.76855,0-1.06152l2.39746-2.39648c.29297-.29297.29297-.76758,0-1.06055-.29297-.29199-.76758-.29395-1.06055,0l-2.39746,2.39648c-.4248.4248-.65918.99023-.65918,1.59082,0,.60156.23438,1.16699.65918,1.5918l4.64941,4.64844c.4248.4248.99023.65918,1.59082.65918s1.16602-.23438,1.59082-.65918l6.00293-6.00293c.17566-.17578.30994-.37964.41736-.5957.4635,2.39355-.72485,3.43652-.92053,4.54346-.12769.78906.40845,1.53198,1.19751,1.65967.15991.02588.323.02466.48242-.00342.83447-.07715,1.39001-.62646,1.34448-1.93823-.04541-1.31177-.59863-4.76416-1.43213-5.78491Z"
      fill="currentColor"
    />
  </svg>`;
};
